import {createEntityService} from "base/entity/service";
import {Service as DefaultService} from "app/common/service";
import {
    createMspeezfitness,
    createMspeezfitnessList,
    mspeezfitness_api_adapter,
    mspeezfitness_list_api_adapter,
} from "app/mspeezfitness/Mspeezfitness";

const entityService = createEntityService(
    "/api/app/mspeezfitness",
    createMspeezfitness,
    createMspeezfitnessList,
    mspeezfitness_api_adapter,
    mspeezfitness_list_api_adapter
);

export const MspeezfitnessService = DefaultService(entityService);
